import {
  GET_ALL_SUBSCRIPTION,
  GET_RUNNING_SUBSCRIPTION,
  GET_SUBSCRIPTION_HISTORY,
  GET_DASHBOARD_DETAILS,
  GET_ALL_CARDS,
} from "./types";
import axios from "axios";
import { toast } from "react-toastify";
const PROXY = process.env.REACT_APP_URL + "api/";

export const getAllSubscription = () => async (dispatch) => {
  const res = await axios.get(`${PROXY}subscription/user/subscription-discount-check`);
  dispatch({
    type: GET_ALL_SUBSCRIPTION,
    payload: res?.data?.result,
  });
  return res?.data?.result;
};

export const buySubscription = (data) => async (dispatch) => {
  const res = await axios.post(`${PROXY}subscription/user/add`, data);
  return res;
};

export const runningSubscription = (id) => async (dispatch) => {
  const res = await axios.patch(`${PROXY}subscription/running/${id}`);
  dispatch({
    type: GET_RUNNING_SUBSCRIPTION,
    payload: res?.data,
  });
  return res?.data;
};

export const dashboardSubscription = () => async (dispatch) => {
  const res = await axios.get(`${PROXY}subscription/dashboard`);
  dispatch({
    type: GET_DASHBOARD_DETAILS,
    payload: res?.data?.result,
  });
  return res?.data?.result;
};

export const getUserSubscription = (page,limit) => async (dispatch) => {
  const res = await axios.get(`${PROXY}subscription/user/get?page=${page}&limit=${limit}`);
  dispatch({
    type: GET_SUBSCRIPTION_HISTORY,
    payload: res?.data.result,
  });
  return res?.data?.result;
};

export const ChangeTenantStatus = (data) => async (dispatch) => {
  const res = await axios.put(
    `${PROXY}user/rental-listing?rental_list=${data}`
  );
  toast.success(res.data.message);
  return res;
};

export const makePayment = (data) => async (dispatch) => {
  const res = await axios.post(`${PROXY}owner/make-payment`, data);
  return res;
};

export const getCardType = () => async (dispatch) => {
  const res = await axios.get(`${PROXY}owner/list-payment`);
  dispatch({
    type: GET_ALL_CARDS,
    payload: res?.data?.result,
  });
  return res.data.result;
};
